import styled from 'styled-components';

export const Logo = styled.img`
  width: 260px;
  margin-bottom: 24px;
`;

export const StyledGrid = styled.div`
  background: url('/assets/img/auth-layout.png') no-repeat top left;
`;